import { useState } from "react";
import "./DeleteProductImage.scss";
import firebase from "firebase/app";
import "firebase/storage";
import "firebase/firestore";

const DeleteProductImage = ({
  isOpen,
  onClose,
  imageURL,
  productId,
  onSuccess,
  onError,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!imageURL) return;
    setIsDeleting(true);
    try {
      // Firebase Storage se delete
      const storageRef = firebase.storage().refFromURL(imageURL);
      await storageRef.delete();

      // Firestore document update
      const productRef = firebase.firestore().collection("products").doc(productId);
      await productRef.update({
        images: firebase.firestore.FieldValue.arrayRemove(imageURL),
      });

      if (onSuccess) onSuccess(imageURL);
    } catch (err) {
      console.error("Error deleting image:", err);
      if (onError) onError(err);
    } finally {
      setIsDeleting(false);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal">
        <p>Are you sure you want to delete this image?</p>
        <div className="delete-modal-buttons">
          <button
            onClick={handleDelete}
            disabled={isDeleting}
            className="confirm-btn"
          >
            {isDeleting ? "Deleting..." : "Yes, Delete"}
          </button>
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="cancel-btn"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteProductImage;
